import React, { useState } from 'react'
import { ChevronDown, Remove } from './../NewIcons'
import FormCheckbox from '../FormCheckbox/FormCheckbox'
import { useRef } from 'react'

const Chip = ({ placeholder, size, variant, icon, iconPos, onClick, selected, backgroundVariant }) => {
  return !!onClick ? (
    <button
      style={{ backgroundColor: selected ? 'lightgray' : undefined }}
      className={'chip chip--clickable chip--' + (size ? size : 'md') + (variant ? ' chip--' + variant : '') + (backgroundVariant ? ' chip--bg-' + backgroundVariant : '')}
      onClick={onClick}
      tabIndex={onClick ? 0 : undefined}
    >
      {icon && iconPos === 'left' && <div className="chip__icon">{icon}</div>}
      {placeholder && <p className="chip__placeholder">{placeholder}</p>}
      {icon && iconPos !== 'left' && <div className="chip__icon">{icon}</div>}
    </button>
  ) : (
    <div
      style={{ backgroundColor: selected ? 'lightgray' : undefined }}
      className={'chip chip--' + (size ? size : 'md') + (variant ? ' chip--' + variant : '') + (backgroundVariant ? ' chip--bg-' + backgroundVariant : '')}
      tabIndex={onClick ? 0 : undefined}
    >
      {icon && iconPos === 'left' && <div className="chip__icon">{icon}</div>}
      {placeholder && <p className="chip__placeholder">{placeholder}</p>}
      {icon && iconPos !== 'left' && <div className="chip__icon">{icon}</div>}
    </div>
  )
}

export const ChipDropdown = ({ placeholder, size, options, value, setValue }) => {
  const [optionsOpen, setOptionsOpen] = useState(false)

  return (
    <div className={'chip-dropdown chip-dropdown--' + (size ? size : 'md')}>
      <Chip
        placeholder={placeholder}
        size={size}
        icon={<ChevronDown />}
        onClick={() => setOptionsOpen(!optionsOpen)}
      />
      {optionsOpen && (
        <div className="chip-dropdown__options">
          {options?.map((option, index) => (
            <button
              key={index}
              onClick={() => {
                setOptionsOpen(false)
                setValue(option.value)
              }}
              className={
                'chip-dropdown__option' +
                (option.value == value ? ' chip-dropdown__option--selected' : '')
              }
            >
              {option.label}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}

export const ChipAttributiDropdown = ({ placeholder, size, options, value, setValue }) => {
  const [optionsOpen, setOptionsOpen] = useState(false)
  const ref = useRef()

  return (
    <div
      className={'chip-dropdown chip-dropdown--' + (size ? size : 'md')}
      ref={ref}
      tabIndex={0}
      onBlur={(e) => {
        if (ref.current && !ref.current.contains(e.relatedTarget)) {
          setOptionsOpen(false)
        }
      }}
    >
      <Chip
        placeholder={placeholder}
        size={size}
        icon={<ChevronDown />}
        onClick={() => setOptionsOpen(!optionsOpen)}
      />
      {optionsOpen && (
        <div className="chip-dropdown__options">
          {options?.map((option, index) => (
            <div
              key={index}
              onClick={() => {
                setOptionsOpen(false)
                setValue(option)
              }}
              className={
                'chip-dropdown__option' +
                (option.chiave == value ? ' chip-dropdown__option--selected' : '')
              }
            >
              {option.nome}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export const ChipMultipleDropdown = ({
  placeholder,
  size,
  options,
  value,
  setValue,
  multiple = false,
}) => {
  const [optionsOpen, setOptionsOpen] = useState(false)
  const ref = useRef()

  // Gestione selezione multipla
  const isSelected = (val) =>
    multiple ? Array.isArray(value) && value.some((v) => v === val) : value === val

  const handleOptionChange = (optionValue) => {
    if (multiple) {
      if (isSelected(optionValue)) {
        setValue(value.filter((v) => v !== optionValue))
      } else {
        setValue([...(value || []), optionValue])
      }
    } else {
      setValue(optionValue)
      setOptionsOpen(false)
    }
  }

  return (
    <div
      className={'chip-multiple-dropdown chip-multiple-dropdown--' + (size ? size : 'md')}
      ref={ref}
      tabIndex={0}
      onBlur={(e) => {
        if (ref.current && !ref.current.contains(e.relatedTarget)) {
          setOptionsOpen(false)
        }
      }}
    >
      <Chip
        placeholder={placeholder}
        size={size}
        icon={<ChevronDown />}
        onClick={() => setOptionsOpen(!optionsOpen)}
      />
      {optionsOpen && (
        <div className="chip-multiple-dropdown__options">
          {options?.map((option, index) => (
            <div
              key={index}
              className={
                'chip-multiple-dropdown__option' +
                (isSelected(option.value) ? ' chip-multiple-dropdown__option--selected' : '')
              }
              onClick={multiple ? undefined : () => handleOptionChange(option.value)}
            >
              {multiple && (
                <FormCheckbox
                  checked={isSelected(option.value)}
                  onChange={() => handleOptionChange(option.value)}
                  label={option.label}
                  size="sm"
                />
              )}
              {!multiple && option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export const ChipCloseFilter = ({ placeholder, size, onClose, backgroundVariant }) => {
  return (
    <Chip
      placeholder={placeholder}
      size={size}
      icon={<Remove />}
      onClick={onClose}
      variant="close-filter"
      backgroundVariant={backgroundVariant}
    />
  )
}

export default React.memo(Chip)
